import { banco } from '../db/banco'
import { novoRegistroBase } from '../db/tipos'
import { gravarLocalEEnfileirar } from '../sync/outbox'

// Ao fechar um pedido, memoriza a tabela usada em cada marca para aquele cliente.
// So grava quando o sub-pedido tem tabela (nunca apaga memoria com null).
// Preserva o vinculo existente (ex.: codigo_cliente_na_representada).
export async function aprenderTabelasDoPedido(pedidoId: string): Promise<void> {
  const pedido = await banco.pedidos.get(pedidoId)
  if (!pedido) return
  const subPedidos = await banco.sub_pedidos
    .where('pedido_id').equals(pedidoId)
    .filter((s) => s.apagado_em === null && s.status !== 'cancelado' && s.tabela_preco_id !== null)
    .toArray()
  for (const sub of subPedidos) {
    const existente = await banco.clientes_representadas
      .where('[cliente_id+representada_id]')
      .equals([pedido.cliente_id, sub.representada_id])
      .filter((v) => v.apagado_em === null)
      .first()
    if (existente) {
      // Escolhida a mao na ficha do cliente (10/10): o pedido nao desfaz --
      // enquanto ela estiver disponivel (viva e ativa, o mesmo criterio do
      // pedido). Fixa desativada/apagada: o pedido ja mostra todas as tabelas
      // da marca (tabelaFixa.ts), entao aprender volta a valer e a fixa morta e
      // solta; senao a preferencia ficava congelada (code review 11/10, ponto 9).
      if (existente.tabela_preco_fixa) {
        const fixa = existente.tabela_preco_padrao_id
          ? await banco.tabelas_preco.get(existente.tabela_preco_padrao_id)
          : undefined
        if (fixa && fixa.apagado_em === null && fixa.ativa) continue
      } else if (existente.tabela_preco_padrao_id === sub.tabela_preco_id) {
        continue
      }
      await gravarLocalEEnfileirar('clientes_representadas', {
        ...existente, tabela_preco_padrao_id: sub.tabela_preco_id, tabela_preco_fixa: false,
      })
    } else {
      await gravarLocalEEnfileirar('clientes_representadas', {
        ...novoRegistroBase(),
        cliente_id: pedido.cliente_id,
        representada_id: sub.representada_id,
        codigo_cliente_na_representada: null,
        tabela_preco_padrao_id: sub.tabela_preco_id,
        observacoes: null,
      })
    }
  }
}
